import React, { useCallback, useState } from 'react';
import { Button } from '@patternfly/react-core';
import _ from 'lodash';

import useBoolean from 'utils/hooks/useBoolean';
import ModelType from '../ModelType';
import EditItemModal from 'components/Modals/EditItemModal';
import ComponentPropTypes from './ComponentPropTypes';
import { useTranslation } from 'localization/useTranslation';

const PlotlinesModalComponent = ({ model, value, onChange }) => {
  const [isSignalSelectorOpen, openSignalSelector, closeSignalSelector] = useBoolean(false);
  const T = useTranslation();
  const [lines, setLines] = useState(!_.isEmpty(value) ? value : { lines: [] });
  const [originalLines, setOriginalLines] = useState(!_.isEmpty(value) ? _.cloneDeep(value) : { lines: [] });
  const localmodel = [
    {
      path: 'lines',
      type: ModelType.PLOTLINES
    }
  ];

  const onSave = useCallback(() => {
    onChange(model, lines);
    setOriginalLines(_.cloneDeep(lines));
    closeSignalSelector();
  }, [closeSignalSelector, lines, model, onChange]);

  const onCancel = useCallback(() => {
    setLines(originalLines);
    onChange(model, originalLines);
    closeSignalSelector();
  }, [closeSignalSelector, model, onChange, originalLines]);

  return (
    <>
      <Button onClick={openSignalSelector}>{ T.common.manage }</Button>
      <EditItemModal
        isOpen={isSignalSelectorOpen}
        title={T.modals.selectsignals.title}
        item={lines}
        setItem={setLines}
        models={localmodel}
        onCancel={onCancel}
        onSave={onSave}
        help="panels/common/plotlines/list.md"
      />

    </>);
};

PlotlinesModalComponent.propTypes = ComponentPropTypes;

export default React.memo(PlotlinesModalComponent);
